/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-no-useless-fragment */
import {
  Alert,
  Badge,
  Box,
  Button,
  Fieldset,
  Grid,
  Group,
  Input,
  Modal,
  NumberInput,
  Paper,
  SegmentedControl,
  Select,
  SimpleGrid,
  Space,
  Stack,
  Text,
  Textarea,
} from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useForm } from '@mantine/form';
import { showNotification } from '@mantine/notifications';
import {
  IconAlertTriangle,
  IconCalculator,
  IconCalendar,
  IconClearAll,
  IconDeviceFloppy,
  IconFileImport,
  IconNotes,
  IconRuler2,
} from '@tabler/icons-react';
import { useEffect, useRef, useState } from 'react';
import {
  Relacao,
  Status,
  TipoCodigo,
  gerenciarVeiculoCompartilhadoMovimentacao,
} from '../../../../../business/events/general';
import {
  MeasurementConversionErrorType,
  calculateCommissionMovements,
  calculateDestinationMovements,
  calculateEquipmentMovements,
  calculateHash,
  calculatePackagingMovements,
  calculateServiceMovements,
  calculateTreatmentMovements,
  calculateVehicleMovements,
} from '../../../../../business/events/measurement';
import PageSection from '../../../../../components/core/PageSection/PageSection';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import useCurrentUser from '../../../../../hooks/useCurrentUser';
import { MovementType, UnitOfMeasureType } from '../../../../../models/core/cache.type';
import { Action } from '../../../../../models/core/core.type';
import { Permission } from '../../../../../models/core/departments.type';
import {
  EventDocumentType,
  EventMeasurementMovementType,
  EventMeasurementType,
  EventType,
} from '../../../../../models/core/events.type';
import eventsService from '../../../../../services/core/events.service';
import { Feature } from '../../../../../utils/constants.utils';
import { formatDateStringToDate } from '../../../../../utils/formatter.utils';
import { buildFakeAuditObject, newGuid, tryGetDateISOFormat } from '../../../../../utils/helper.utils';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../../../utils/mantine.utils';
import { validate } from '../../../../../utils/permission.utils';
import MovementFormView from './MovementFormView/MovementFormView';
import QuotationPricingModal, { hasPendingQuotationPricing } from './QuotationPricingModal';

type EventFormViewProps = {
  referenceData: {
    unitOfMeasures: UnitOfMeasureType[];
    movementTypeData: MovementType[];
  };
  data: EventType;
  callbackMeasurement(item: EventMeasurementType): void;
  callbackEvent(item: EventType): void;
  zIndex: number;
};

type FormViewData = {
  action: Action;
  dataRecebimento: Date;
  quantidadeOrigem: number | null;
  quantidadeOrigemIdUnidadeMedida: string | null;
  quantidadeDestino: number | null;
  quantidadeDestinoIdUnidadeMedida: string | null;
  elegibleDocsToBeImported: EventDocumentType[];
  documentoImportado: string;
  tempo: number | null;
  tempoIdUnidadeMedida: string | null;
  observacao: string | null;
};

enum CalculationQuantitySource {
  Origin = 'origin',
  Destination = 'destination',
}

type CalculationQuantityData = Pick<
  EventMeasurementType,
  | 'quantidadeOrigem'
  | 'quantidadeOrigemIdUnidadeMedida'
  | 'quantidadeDestino'
  | 'quantidadeDestinoIdUnidadeMedida'
> & {
  movimentacoes?: EventMeasurementMovementType[];
};

const inferCalculationQuantitySource = (
  measurement: CalculationQuantityData | null | undefined
): CalculationQuantitySource => {
  const hasOrigin =
    measurement?.quantidadeOrigem !== null &&
    measurement?.quantidadeOrigem !== undefined &&
    measurement?.quantidadeOrigemIdUnidadeMedida !== null &&
    measurement?.quantidadeOrigemIdUnidadeMedida !== undefined;
  const hasDestination =
    measurement?.quantidadeDestino !== null &&
    measurement?.quantidadeDestino !== undefined &&
    measurement?.quantidadeDestinoIdUnidadeMedida !== null &&
    measurement?.quantidadeDestinoIdUnidadeMedida !== undefined;

  if (hasOrigin !== hasDestination) {
    return hasDestination ? CalculationQuantitySource.Destination : CalculationQuantitySource.Origin;
  }

  if (!hasOrigin || !hasDestination) {
    return CalculationQuantitySource.Origin;
  }

  const operationalMovements = (measurement.movimentacoes || []).filter(
    (movement) =>
      movement.action !== Action.Delete &&
      !movement.idEventoTolerancia &&
      !!(
        movement.idEventoAcondicionamento ||
        movement.idEventoEquipamento ||
        movement.idEventoVeiculo ||
        movement.idEventoTratamento ||
        movement.idEventoDestinoFinal
      )
  );
  const movementUses = (quantity: number | null, unitOfMeasureId: number | null) =>
    operationalMovements.some(
      (movement) =>
        Number(movement.quantidade) === Number(quantity) &&
        Number(movement.quantidadeIdUnidadeMedida) === Number(unitOfMeasureId)
    );
  const usesOrigin = movementUses(measurement.quantidadeOrigem, measurement.quantidadeOrigemIdUnidadeMedida);
  const usesDestination = movementUses(
    measurement.quantidadeDestino,
    measurement.quantidadeDestinoIdUnidadeMedida
  );

  return usesDestination && !usesOrigin
    ? CalculationQuantitySource.Destination
    : CalculationQuantitySource.Origin;
};

const buildMeasurementTotals = (movimentacoes: EventMeasurementMovementType[] = []) => {
  const activeMovements = movimentacoes.filter((x) => x.action !== Action.Delete);
  const receita = activeMovements.reduce((sum, item) => sum + (item.receita || 0), 0);
  const despesa = activeMovements.reduce((sum, item) => sum + (item.despesa || 0), 0);
  const imposto = activeMovements.reduce((sum, item) => sum + (item.imposto || 0), 0);

  return {
    receita,
    despesa,
    imposto,
    balanco: receita - despesa - imposto,
  };
};

export default function MeasurementFormView(props: EventFormViewProps) {
  const [currentUser] = useCurrentUser();
  const refMovementForm = useRef<any>();
  const [updating, setUpdating] = useState(false);
  const [calculateModal, setCalculateModal] = useState<boolean>(false);
  const [calculating, setCalculating] = useState<boolean>(false);
  const [defineAfterCalculate, setDefineAfterCalculate] = useState<boolean>(false);
  const [newMovementsMessage, setNewMovementsMessage] = useState<boolean>(false);
  const [pricingModalOpened, setPricingModalOpened] = useState(false);
  const [calculationQuantitySource, setCalculationQuantitySource] = useState<CalculationQuantitySource>(() =>
    inferCalculationQuantitySource(props.data.medicao)
  );

  const [data, setMedicao] = useState<{
    medicao: EventMeasurementType | null;
    erros: MeasurementConversionErrorType[];
    hashes: string[];
    key: string;
  }>({
    medicao: props.data.medicao,
    erros: [],
    hashes: [],
    key: newGuid(),
  });

  const cobrancas = props.data.relacoes.filter((x) => x.codigoEventoRelacao === Relacao.Cobranca);
  const elegibleToEditMovements =
    props.data.codigoEventoStatus === Status.Finalizado &&
    (cobrancas.length === 0 ||
      cobrancas.filter((x) => x.codigoEventoStatus !== Status.Finalizado).length === 1);

  const disabled = props.data.codigoEventoStatus !== Status.PendenteMedicao && !elegibleToEditMovements;

  const evento = props.data;
  const residuo = evento.referencia?.contrato?.residuo;
  const servico = evento.referencia?.contrato?.servico;
  const item =
    evento.resumoJSON?.acondicionamento || evento.resumoJSON?.equipamento || evento.resumoJSON?.servico;
  const quotationNeedsPricingDefinition = hasPendingQuotationPricing(evento);
  const form = useForm<FormViewData>({
    initialValues: {
      action: data.medicao ? Action.Nothing : Action.Add,

      dataRecebimento: formatDateStringToDate(
        tryGetDateISOFormat(data?.medicao?.dataRecebimento || props.data.data)
      ),
      quantidadeOrigem: data?.medicao?.quantidadeOrigem || item?.quantidade || null,
      quantidadeOrigemIdUnidadeMedida: item
        ? props.referenceData.unitOfMeasures
            .find((x) => x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')!
            .idUnidadeMedida.toString() || null
        : data?.medicao?.quantidadeOrigemIdUnidadeMedida?.toString() || null,
      documentoImportado: '',

      quantidadeDestino: data?.medicao?.quantidadeDestino || null,
      quantidadeDestinoIdUnidadeMedida: data?.medicao?.quantidadeDestinoIdUnidadeMedida?.toString() || null,

      tempo: data?.medicao?.tempo || null,
      elegibleDocsToBeImported: props.data.documentos
        .filter(
          (x) =>
            ['Nota Fiscal', 'MTR'].includes(x.documentoTipo) && (x.observacao ?? '')?.split('|')?.length > 2
        )
        .sort((a, b) => a.documentoTipo.localeCompare(b.documentoTipo)),
      tempoIdUnidadeMedida: data?.medicao?.tempoIdUnidadeMedida?.toString() || null,

      observacao: data?.medicao?.observacao || '',
    },
    validate: {
      dataRecebimento: (value) => {
        if (Math.abs(value.getFullYear() - new Date().getFullYear()) > 200) {
          return 'Data não suportada';
        }
        return null;
      },
      quantidadeOrigem: (value: number | null, values: FormViewData) => {
        if (
          evento.codigoEventoTipo !== TipoCodigo.Comissao &&
          calculationQuantitySource === CalculationQuantitySource.Origin &&
          (value === null || value === undefined)
        ) {
          return 'Campo obrigatório';
        }
        if ((value === null || value === undefined) && values.quantidadeOrigemIdUnidadeMedida) {
          return 'Campo obrigatório';
        }
        return null;
      },
      quantidadeOrigemIdUnidadeMedida: (value: string | null, values: FormViewData) => {
        if (
          evento.codigoEventoTipo !== TipoCodigo.Comissao &&
          calculationQuantitySource === CalculationQuantitySource.Origin &&
          !value
        ) {
          return 'Campo obrigatório';
        }
        if (value) {
          if (!props.referenceData.unitOfMeasures.find((x) => Number(x.idUnidadeMedida) === Number(value))) {
            return 'Campo obrigatório';
          }
        } else if (values.quantidadeOrigem || values.quantidadeOrigem === 0) {
          return 'Campo obrigatório';
        }
        return null;
      },
      quantidadeDestino: (value: number | null, values: FormViewData) => {
        if (
          evento.codigoEventoTipo !== TipoCodigo.Comissao &&
          calculationQuantitySource === CalculationQuantitySource.Destination &&
          (value === null || value === undefined)
        ) {
          return 'Campo obrigatório';
        }
        if ((value === null || value === undefined) && values.quantidadeDestinoIdUnidadeMedida) {
          return 'Campo obrigatório';
        }
        return null;
      },
      quantidadeDestinoIdUnidadeMedida: (value: string | null, values: FormViewData) => {
        if (
          evento.codigoEventoTipo !== TipoCodigo.Comissao &&
          calculationQuantitySource === CalculationQuantitySource.Destination &&
          !value
        ) {
          return 'Campo obrigatório';
        }
        if (value) {
          if (!props.referenceData.unitOfMeasures.find((x) => Number(x.idUnidadeMedida) === Number(value))) {
            return 'Campo obrigatório';
          }
        } else if (values.quantidadeDestino || values.quantidadeDestino === 0) {
          return 'Campo obrigatório';
        }
        return null;
      },
      tempo: (value: number | null, values: FormViewData) => {
        if (value === null || value === undefined) {
          if (values.tempoIdUnidadeMedida) {
            return 'Campo obrigatório';
          }
          const tolerancias = evento.veiculo?.cotacao?.tolerancias?.map((x) => x.idUnidadeMedida) || [];
          const toleranciasUM = props.referenceData.unitOfMeasures.filter((x) => {
            return tolerancias.indexOf(x.idUnidadeMedida) > -1;
          });

          if (toleranciasUM.findIndex((x) => x.tipo === 'Tempo') > -1) {
            return 'Campo obrigatório';
          }
        }

        return null;
      },
      tempoIdUnidadeMedida: (value: string | null, values: FormViewData) => {
        if (value) {
          if (!props.referenceData.unitOfMeasures.find((x) => Number(x.idUnidadeMedida) === Number(value))) {
            return 'Campo obrigatório';
          }
        } else if (values.tempo || values.tempo === 0) {
          return 'Campo obrigatório';
        }
        return null;
      },
    },
  });

  const buildFormItem = () => {
    const formValues = form.values;
    const refMovementData = refMovementForm.current.validate();
    const movimentacoes = refMovementData.data as EventMeasurementMovementType[];
    const totais = buildMeasurementTotals(movimentacoes);

    const formItem: EventMeasurementType = {
      ...formValues,
      ...buildFakeAuditObject(),
      idEvento: props.data.idEvento,
      idEventoMedicao: data?.medicao?.idEventoMedicao,
      quantidadeOrigem: formValues.quantidadeOrigem || null,
      quantidadeOrigemIdUnidadeMedida: Number(formValues.quantidadeOrigemIdUnidadeMedida) || null,
      quantidadeDestino: formValues.quantidadeDestino || null,
      quantidadeDestinoIdUnidadeMedida: Number(formValues.quantidadeDestinoIdUnidadeMedida) || null,
      tempo: formValues.tempo || null,
      tempoIdUnidadeMedida: Number(formValues.tempoIdUnidadeMedida) || null,
      receita: totais.receita,
      despesa: totais.despesa,
      imposto: totais.imposto,
      balanco: totais.balanco,
    };

    formItem.observacao = formItem.observacao?.trim() || null;
    formItem.movimentacoes = movimentacoes;

    return formItem;
  };

  const persistMeasurement = async (formItem: EventMeasurementType) => {
    try {
      setUpdating(true);
      let response;

      if (formItem.action === Action.Add && !data.medicao?.idEventoMedicao) {
        response = await eventsService.insertMeasurement(formItem);
      } else {
        response = await eventsService.updateMeasurement(formItem);
      }

      for (const x of response.movimentacoes) {
        x.hash = calculateHash(x);
      }

      setMedicao({ medicao: response, erros: [], hashes: [], key: newGuid() });
      props.callbackMeasurement(response);

      showNotification({
        title: 'Evento - Visualizar',
        message: 'Medição definida com sucesso.',
        color: 'green',
      });
    } catch (error: any) {
      showNotification({
        title: 'Evento - Visualizar',
        message: error?.isBusinessException ? error.description : 'Não foi possível difinir a medição.',
        color: 'red',
      });
    } finally {
      setUpdating(false);
    }
  };

  const handleSubmit = async () => {
    if (quotationNeedsPricingDefinition) {
      setPricingModalOpened(true);
      return;
    }

    const formResult = form.validate();
    if (formResult.hasErrors) {
      return;
    }

    const formValues = form.values;
    if (props.data.medicao || data.medicao?.idEventoMedicao) {
      // if (isModified(refMovementForm.current.validate().grandTotal)) {
      //   formValues.action = Action.Modify;
      // } else {
      //   formValues.action = Action.Nothing;
      // }
      formValues.action = Action.Modify;
    }

    const formItem = buildFormItem();
    await persistMeasurement(formItem);
  };

  const clear = () => {
    const movimentacoes = refMovementForm.current.validate().data as EventMeasurementMovementType[];
    const movimentacoesFiltradas = movimentacoes.filter((x) => {
      return !data.hashes.includes(x.hash!);
    });

    setMedicao({
      ...data,
      medicao: {
        ...data.medicao!,
        movimentacoes: movimentacoesFiltradas,
      },
      erros: [],
      hashes: [],
      key: newGuid(),
    });
    setNewMovementsMessage(false);
  };

  const calculate = async (calcularFreteCompartilhado: boolean, definirMedicao = false) => {
    // general data
    let idFornecedor;

    // residue data
    let minimoAceitavel = null;
    let minimoAceitavelUM = null;

    if (residuo?.minimoAceitavelUnidadeMedidaSigla2 === 'col') {
      minimoAceitavel = residuo.minimoAceitavel!;
      minimoAceitavelUM =
        props.referenceData.unitOfMeasures.find(
          (x) => x.idUnidadeMedida === residuo.minimoAceitavelIdUnidadeMedida1
        ) || null;
    }

    // form data
    const { quantidadeOrigem, quantidadeDestino } = form.values;

    const quantidadeOrigemUM = props.referenceData.unitOfMeasures.find(
      (x) => x.idUnidadeMedida === Number(form.values.quantidadeOrigemIdUnidadeMedida)
    );
    const quantidadeDestinoUM = props.referenceData.unitOfMeasures.find(
      (x) => x.idUnidadeMedida === Number(form.values.quantidadeDestinoIdUnidadeMedida)
    );
    let quantidade =
      calculationQuantitySource === CalculationQuantitySource.Destination
        ? quantidadeDestino
        : quantidadeOrigem;
    let quantidadeUM =
      calculationQuantitySource === CalculationQuantitySource.Destination
        ? quantidadeDestinoUM
        : quantidadeOrigemUM;

    const tempo = form.values.tempo!;
    const tempoIdUnidadeMedida = Number(form.values.tempoIdUnidadeMedida!);
    const tempoColetaUM = props.referenceData.unitOfMeasures.find(
      (x) => x.idUnidadeMedida === tempoIdUnidadeMedida
    );

    // movements
    let movimentacoes: EventMeasurementMovementType[] = [];
    let erros: MeasurementConversionErrorType[] = [];

    if (evento.acondicionamento) {
      idFornecedor = Number(evento.acondicionamento.cotacao.idFornecedor);

      const acondicionamentoMovimentacoes = calculatePackagingMovements(
        evento.idEvento,
        evento.codigoEventoReferencia!,
        idFornecedor,
        evento.acondicionamento,
        quantidade!,
        quantidadeUM!,
        residuo?.compra || false,
        props.referenceData.movementTypeData,
        props.referenceData.unitOfMeasures
      );

      movimentacoes = movimentacoes.concat(acondicionamentoMovimentacoes.movimentacoes);
      erros = erros.concat(acondicionamentoMovimentacoes.erros);
    }

    if (evento.equipamento) {
      idFornecedor = Number(evento.equipamento.cotacao.idFornecedor);

      const equipamentoMovimentacoes = calculateEquipmentMovements(
        evento.idEvento,
        evento.codigoEventoReferencia!,
        idFornecedor,
        evento.equipamento,
        quantidade!,
        quantidadeUM!,
        residuo?.compra || false,
        props.referenceData.movementTypeData,
        props.referenceData.unitOfMeasures
      );

      movimentacoes = movimentacoes.concat(equipamentoMovimentacoes.movimentacoes);
      erros = erros.concat(equipamentoMovimentacoes.erros);
    }

    if (gerenciarVeiculoCompartilhadoMovimentacao(evento) && calcularFreteCompartilhado) {
      idFornecedor = Number(evento.veiculo!.cotacao.idFornecedor);

      const veiculoMovimentacoes = calculateVehicleMovements(
        evento.idEvento,
        evento.codigoEventoReferencia!,
        idFornecedor,
        evento.veiculo!,
        quantidade!,
        quantidadeUM!,
        tempo,
        tempoColetaUM || null,
        evento.veiculo?.cotacao.minimoAceitavel ?? minimoAceitavel,
        props.referenceData.unitOfMeasures.find(
          (x) => x.idUnidadeMedida === evento.veiculo?.cotacao.minimoAceitavelIdUnidadeMedida
        ) ?? minimoAceitavelUM,
        residuo?.compra || false,
        residuo?.cobrarTolerancia || false,
        props.referenceData.movementTypeData,
        props.referenceData.unitOfMeasures
      );

      movimentacoes = movimentacoes.concat(veiculoMovimentacoes.movimentacoes);
      erros = erros.concat(veiculoMovimentacoes.erros);
    }

    if (evento.tratamento) {
      idFornecedor = Number(evento.tratamento.cotacao.idFornecedor);

      const tratamentoMovimentacoes = calculateTreatmentMovements(
        evento.idEvento,
        evento.codigoEventoReferencia!,
        idFornecedor,
        evento.tratamento,
        quantidade!,
        quantidadeUM!,
        minimoAceitavel,
        minimoAceitavelUM,
        residuo?.compra || false,
        residuo?.cobrarTolerancia || false,
        props.referenceData.movementTypeData,
        props.referenceData.unitOfMeasures
      );

      movimentacoes = movimentacoes.concat(tratamentoMovimentacoes.movimentacoes);
      erros = erros.concat(tratamentoMovimentacoes.erros);
    }

    if (evento.destinoFinal) {
      idFornecedor = Number(evento.destinoFinal.cotacao.idFornecedor);

      const destinoFinalMovimentacoes = calculateDestinationMovements(
        evento.idEvento,
        evento.codigoEventoReferencia!,
        evento.resumoJSON!.cliente!.idCliente!,
        idFornecedor,
        evento.destinoFinal,
        quantidade!,
        quantidadeUM!,
        minimoAceitavel,
        minimoAceitavelUM,
        residuo?.compra || false,
        residuo?.cobrarTolerancia || false,
        props.referenceData.movementTypeData,
        props.referenceData.unitOfMeasures
      );

      movimentacoes = movimentacoes.concat(destinoFinalMovimentacoes.movimentacoes);
      erros = erros.concat(destinoFinalMovimentacoes.erros);
    }

    if (evento.servico) {
      quantidade = evento.servico.quantidade;
      quantidadeUM = props.referenceData.unitOfMeasures.find(
        (x) => x.idUnidadeMedida === Number(evento.servico?.frequenciaIdUnidadeMedida1)
      );

      idFornecedor = Number(evento.servico.cotacao.idFornecedor);

      const servicoMovimentacoes = calculateServiceMovements(
        evento.idEvento,
        evento.codigoEventoReferencia!,
        idFornecedor,
        evento.servico,
        quantidade,
        quantidadeUM!,
        residuo?.compra || false,
        props.referenceData.movementTypeData,
        props.referenceData.unitOfMeasures
      );

      movimentacoes = movimentacoes.concat(servicoMovimentacoes.movimentacoes);
      erros = erros.concat(servicoMovimentacoes.erros);
    }

    if (evento.referencia?.comissao) {
      idFornecedor = evento.referencia?.comissao.idEntidade;

      const comissaoMovimentacoes = calculateCommissionMovements(
        evento.idEvento,
        evento.codigoEventoReferencia!,
        idFornecedor,
        evento.referencia.comissao,
        props.referenceData.movementTypeData,
        props.referenceData.unitOfMeasures
      );

      movimentacoes = movimentacoes.concat(comissaoMovimentacoes.movimentacoes);
      erros = erros.concat(comissaoMovimentacoes.erros);
    }

    try {
      const formItem = buildFormItem();

      // movements - hash
      for (const x of movimentacoes) {
        x.action = Action.Add;
        x.id = newGuid();
        x.hash = calculateHash(x);

        if (formItem.movimentacoes.findIndex((y) => y.hash === x.hash) === -1) {
          formItem.movimentacoes.push(x);
        }
      }

      Object.assign(formItem, buildMeasurementTotals(formItem.movimentacoes));

      setMedicao({ medicao: formItem, erros, hashes: movimentacoes.map((x) => x.hash!), key: newGuid() });
      if (
        movimentacoes.length !== (refMovementForm.current.validate().data.length ?? 0) ||
        (movimentacoes.length > 0 && !data.medicao)
      ) {
        setNewMovementsMessage(true);
      }

      if (definirMedicao) {
        if (props.data.medicao || data.medicao?.idEventoMedicao) {
          form.values.action = Action.Modify;
          formItem.action = Action.Modify;
        }

        await persistMeasurement(formItem);
      }

      // showNotification({
      //   title: 'Evento - Visualizar',
      //   message: `Medição calculada com sucesso.`,
      //   color: 'green',
      // });
    } catch (error: any) {
      showNotification({
        title: 'Evento - Visualizar',
        message: error?.isBusinessException ? error.description : `Não foi possível calcular a medição.`,
        color: 'red',
      });
    }
  };

  const preCalculate = async (definirMedicao = false) => {
    if (quotationNeedsPricingDefinition) {
      setPricingModalOpened(true);
      return;
    }

    const formResult = form.validate();
    if (formResult.hasErrors) {
      return;
    }

    // props.data.veiculo?.cotacao?.cobrarSeCompartilhado
    if (props.data.idEventoVeiculoCompartilhado && props.data.resumoJSON?.veiculoCompartilhado) {
      setDefineAfterCalculate(definirMedicao);
      setCalculateModal(true);
    } else {
      await calculate(true, definirMedicao);
    }
  };

  const buildResidueHeader = () => {
    if (!residuo) {
      return <></>;
    }

    return (
      <Group>
        <ProfileCardLink
          id={residuo.idResiduo.toString()}
          name={residuo.residuoCliente}
          nameSize="md"
          description={`Código IBAMA: ${residuo.codigoIBAMA || '-'} | Perigoso: ${
            residuo.residuoClientePerigoso ? 'Sim' : 'Não'
          }`}
          descriptionSize="sm"
          linkPrefix="residues"
          showLink={false}
        />
        <Group>
          <Stack gap="xs">
            {residuo.estimativa && (
              <Badge variant="outline" size="md" color={Feature.Home.Event.color}>
                {`Estimativa: ${residuo.estimativa} ${residuo.estimativaUnidadeMedida1} / ${residuo.estimativaUnidadeMedida2}`}
              </Badge>
            )}
            {residuo.minimoAceitavel ? (
              <Badge variant="outline" size="md" color="orange">
                {`Mínimo Aceitável: ${residuo.minimoAceitavel} ${residuo.minimoAceitavelUnidadeMedida1} / ${residuo.minimoAceitavelUnidadeMedida2}`}
              </Badge>
            ) : (
              <></>
            )}
          </Stack>
          <Stack gap="xs">
            {residuo.compra && (
              <Badge variant="outline" size="md" color={Feature.Home.Event.color}>
                Compra
              </Badge>
            )}
            {residuo.cobrarTolerancia && (
              <Badge variant="outline" size="md" color={Feature.Home.Event.color}>
                Cobrar Tolerâncias
              </Badge>
            )}
          </Stack>
        </Group>
      </Group>
    );
  };

  const buildServiceHeader = () => {
    if (!servico) {
      return <></>;
    }

    return (
      <Group>
        <ProfileCardLink
          id={servico.idServico.toString()}
          name={servico.servico}
          nameSize="md"
          description={servico.servicoDescricao}
          descriptionSize="sm"
          linkPrefix="services"
          showLink={false}
        />
        <Badge variant="outline" size="md" color={Feature.Home.Event.color}>
          {`${servico.residuoAcondicionamento || servico.residuoEquipamento || 'Fornecedor'}`}
        </Badge>
      </Group>
    );
  };

  const importQuantities = () => {
    const docs = form.values.elegibleDocsToBeImported;

    if (!docs.length) {
      return;
    }

    let docDate = new Date();
    let qtdIndicada = null;
    let qtdIndicadaUm = '';
    let qtdRecebida = null;
    let qtdRecebidaUm = '';

    for (const doc of docs) {
      const obs = doc.observacao?.split('|');
      docDate = doc.data ? new Date(formatDateStringToDate(doc.data.toString())) : new Date();

      if (doc.documentoTipo === 'Nota Fiscal') {
        const tempQtdIndicada = obs?.[2] || null;
        if (tempQtdIndicada) {
          qtdIndicada = tempQtdIndicada;
          qtdIndicadaUm = obs?.[3]?.toLowerCase() ?? '';

          if (qtdIndicadaUm === 't') {
            qtdIndicadaUm = 'ton';
          } else if (qtdIndicadaUm === 'm3') {
            qtdIndicadaUm = 'm³';
          }
        }
      } else {
        qtdIndicada = obs?.[3] ?? null;
        qtdRecebida = obs?.[1] ?? null;
        qtdRecebidaUm = obs?.[2] ?? '';

        if (qtdRecebidaUm === 'Tonelada') {
          qtdRecebidaUm = 'ton';
        }
        qtdIndicadaUm = qtdRecebidaUm;
      }
    }

    const qtdIndicadaUmId =
      props.referenceData.unitOfMeasures
        .find((x) => x.unidadeMedidaSigla === qtdIndicadaUm)
        ?.idUnidadeMedida?.toString() ?? '';
    const qtdRecebidaUmId =
      props.referenceData.unitOfMeasures
        .find((x) => x.unidadeMedidaSigla === qtdRecebidaUm)
        ?.idUnidadeMedida?.toString() ?? '';

    if (!qtdIndicada && !qtdRecebida) {
      return;
    }

    const nextValues = {
      ...form.values,
      dataRecebimento: docDate,
      quantidadeOrigem: qtdIndicada ? Number(qtdIndicada) : form.values.quantidadeOrigem,
      quantidadeOrigemIdUnidadeMedida: qtdIndicada
        ? qtdIndicadaUmId
        : form.values.quantidadeOrigemIdUnidadeMedida,
      quantidadeDestino: qtdRecebida ? Number(qtdRecebida) : form.values.quantidadeDestino,
      quantidadeDestinoIdUnidadeMedida: qtdRecebida
        ? qtdRecebidaUmId
        : form.values.quantidadeDestinoIdUnidadeMedida,
      documentoImportado: `${qtdIndicada}|${qtdRecebida} ${qtdRecebidaUm}`,
    };

    form.setValues(nextValues);
    setCalculationQuantitySource(
      inferCalculationQuantitySource({
        quantidadeOrigem: nextValues.quantidadeOrigem,
        quantidadeOrigemIdUnidadeMedida: Number(nextValues.quantidadeOrigemIdUnidadeMedida) || null,
        quantidadeDestino: nextValues.quantidadeDestino,
        quantidadeDestinoIdUnidadeMedida: Number(nextValues.quantidadeDestinoIdUnidadeMedida) || null,
        movimentacoes: data.medicao?.movimentacoes || [],
      })
    );
  };

  useEffect(() => {
    importQuantities();
  }, []);

  return (
    <div>
      <QuotationPricingModal
        opened={pricingModalOpened}
        event={evento}
        unitOfMeasures={props.referenceData.unitOfMeasures}
        zIndex={props.zIndex}
        onClose={() => setPricingModalOpened(false)}
        onSaved={props.callbackEvent}
      />

      <Modal
        opened={calculateModal}
        closeOnClickOutside={false}
        closeOnEscape={false}
        onClose={() => setCalculateModal(false)}
        size="auto"
        title="Gostaria de calcular o valor de frete?"
        zIndex={props.zIndex + 1}
      >
        <div>
          <Paper shadow="xs" p="md" withBorder>
            <Box w={450}>
              <Text>
                Esse evento possui uma cotação de veículo e também está compartilhando o frete. Ao confirmar,
                os custos de frete original serão adicionados às movimentações.
              </Text>
            </Box>
          </Paper>
          <Space h="xl" />

          <Group justify="right">
            <Button
              color="secondary"
              disabled={updating}
              onClick={async () => {
                setCalculateModal(false);
                await calculate(false, defineAfterCalculate);
                setDefineAfterCalculate(false);
              }}
            >
              Não
            </Button>
            <Button
              color="primary"
              loading={updating}
              onClick={async () => {
                setCalculateModal(false);
                await calculate(true, defineAfterCalculate);
                setDefineAfterCalculate(false);
              }}
            >
              Sim
            </Button>
          </Group>
        </div>
      </Modal>

      <Group justify="space-between">
        <PageSection
          size="lg"
          color={Feature.Home.Event.color}
          label="Medição"
          text="Informações de medição do evento."
        />
        <Button
          color="accent"
          leftSection={<IconDeviceFloppy size={18} />}
          type="button"
          form="event-measurement"
          onClick={handleSubmit}
          loading={updating}
          hidden={disabled}
          disabled={!validate(Permission.EventEdit, currentUser.permissoes)}
        >
          Definir Medição
        </Button>
      </Group>
      <Space h="xs" />

      <Paper shadow="xs" p="md" withBorder>
        <Group justify="space-between">
          {residuo ? buildResidueHeader() : servico ? buildServiceHeader() : <></>}
        </Group>
        <Space h="sm" />

        <Paper shadow="xs" p="md" withBorder>
          <Group justify="space-between">
            <PageSection
              size="md"
              color={Feature.Home.Event.color}
              label="Recebimento de carga e verificação de serviço"
              text="Informações de recebimento de carga e verificação de serviço."
            />
            <Group>
              <Button
                color="secondary"
                leftSection={<IconClearAll size={18} />}
                hidden={disabled}
                onClick={clear}
              >
                Limpar
              </Button>
              {}
              <Button
                color={Feature.Home.Event.color}
                leftSection={<IconFileImport size={18} />}
                type="button"
                onClick={importQuantities}
                hidden={disabled || form.values.elegibleDocsToBeImported.length === 0}
                loading={calculating}
              >
                Importar
              </Button>
              <Button
                color="primary"
                leftSection={<IconCalculator size={18} />}
                type="button"
                onClick={() => {
                  setNewMovementsMessage(false);
                  setCalculating(true);
                  preCalculate();
                  setTimeout(() => {
                    setCalculating(false);
                  }, 2000);
                }}
                hidden={disabled}
                loading={calculating}
                disabled={!validate(Permission.EventEdit, currentUser.permissoes)}
              >
                Calcular
              </Button>
              <Button
                color="orange"
                leftSection={<IconCalculator size={18} />}
                type="button"
                onClick={() => {
                  setNewMovementsMessage(false);
                  setCalculating(true);
                  preCalculate(true);
                  setTimeout(() => {
                    setCalculating(false);
                  }, 2000);
                }}
                hidden={disabled}
                loading={calculating || updating}
                disabled={!validate(Permission.EventEdit, currentUser.permissoes)}
              >
                Calcular e Definir
              </Button>
            </Group>
          </Group>
          <Space h="xs" />

          {newMovementsMessage && (
            <>
              <Alert
                icon={<IconAlertTriangle size={32} />}
                title="Novas movimentações"
                color="yellow"
                withCloseButton
                onClose={() => setNewMovementsMessage(false)}
              >
                Novas movimentações foram adicionadas. Verifique-as.
              </Alert>
              <Space h="xs" />
            </>
          )}

          {/* {quotationNeedsPricingDefinition && (
            <>
              <Alert
                icon={<IconAlertTriangle size={16} />}
                title="Preços pendentes para a medição"
                color="yellow"
              >
                Antes de calcular ou definir a medição, preencha completamente os preços pendentes do
                fornecedor e do cliente nas cotações do evento.
              </Alert>
              <Space h="xs" />
            </>
          )} */}

          <form id="event-measurement" noValidate>
            <Grid columns={4}>
              <Grid.Col span={1}>
                <DatePickerInput
                  leftSection={<IconCalendar size={15} />}
                  label="Data do Recebimento"
                  locale="pt-br"
                  valueFormat="DD/MM/YYYY"
                  maxDate={new Date()}
                  clearable={false}
                  required
                  disabled={disabled}
                  {...form.getInputProps('dataRecebimento')}
                />
              </Grid.Col>
              <Grid.Col span={1} />
              <Grid.Col span={2}>
                <Input.Wrapper label="Tempo de Coleta/Serviço">
                  <div />
                </Input.Wrapper>
                <Group gap="xs">
                  <NumberInput
                    style={{ width: 125 }}
                    placeholder="Tempo"
                    min={0}
                    decimalScale={2}
                    step={0.01}
                    stepHoldDelay={500}
                    stepHoldInterval={(t) => Math.max(1000 / t ** 2, 25)}
                    disabled={disabled || props.data.codigoEventoTipo === TipoCodigo.Comissao}
                    {...form.getInputProps('tempo')}
                  />
                  <Select
                    leftSection={<IconRuler2 size={15} />}
                    placeholder="Selecione..."
                    data={transformComboBoxGroupDataFromV5toV7(
                      props.referenceData.unitOfMeasures
                        .filter(
                          (x) =>
                            x.tipo === 'Tempo' &&
                            (x.unidadeMedidaSigla === 'h' || x.unidadeMedidaSigla === 'd')
                        )
                        .map((x) => {
                          return {
                            value: x.idUnidadeMedida.toString(),
                            label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
                            group: x.tipo,
                          };
                        })
                    )}
                    searchable
                    clearable
                    disabled={disabled || props.data.codigoEventoTipo === TipoCodigo.Comissao}
                    {...form.getInputProps('tempoIdUnidadeMedida')}
                  />
                </Group>
              </Grid.Col>
            </Grid>
            <Space h="xs" />

            <Fieldset
              styles={{ legend: { width: 'auto' } }}
              legend={
                <Group gap="xs">
                  <Text size="sm" fw={500}>
                    Base para cálculo
                  </Text>
                  {props.data.codigoEventoTipo !== TipoCodigo.Comissao ? (
                    <SegmentedControl
                      value={calculationQuantitySource}
                      onChange={(value) => {
                        setCalculationQuantitySource(value as CalculationQuantitySource);
                        form.clearFieldError('quantidadeOrigem');
                        form.clearFieldError('quantidadeOrigemIdUnidadeMedida');
                        form.clearFieldError('quantidadeDestino');
                        form.clearFieldError('quantidadeDestinoIdUnidadeMedida');
                      }}
                      size="sm"
                      data={[
                        { label: 'Origem', value: CalculationQuantitySource.Origin },
                        { label: 'Destino', value: CalculationQuantitySource.Destination },
                      ]}
                      disabled={disabled}
                    />
                  ) : (
                    <></>
                  )}
                </Group>
              }
            >
              <Grid columns={4}>
                <Grid.Col span={2}>
                  <Input.Wrapper
                    label="Quantidade de Origem"
                    required={
                      props.data.codigoEventoTipo !== TipoCodigo.Comissao &&
                      calculationQuantitySource === CalculationQuantitySource.Origin
                    }
                  >
                    <div />
                  </Input.Wrapper>
                  <Group gap="xs">
                    <NumberInput
                      style={{ width: 125 }}
                      placeholder="Quantidade"
                      // min={!isUnit ? 0 : 1}
                      // decimalScale={!isUnit ? 3 : 0}
                      // step={!isUnit ? 0.001 : 1}
                      min={0}
                      decimalScale={3}
                      step={0.001}
                      stepHoldDelay={500}
                      stepHoldInterval={(t) => Math.max(1000 / t ** 2, 25)}
                      disabled={disabled || props.data.codigoEventoTipo === TipoCodigo.Comissao}
                      {...form.getInputProps('quantidadeOrigem')}
                    />
                    <Select
                      leftSection={<IconRuler2 size={15} />}
                      placeholder="Selecione..."
                      data={transformComboBoxGroupDataFromV5toV7(
                        props.referenceData.unitOfMeasures
                          .filter(
                            (x) =>
                              x.tipo === 'Massa' ||
                              x.tipo === 'Volume' ||
                              (x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
                          )
                          .map((x) => {
                            return {
                              value: x.idUnidadeMedida.toString(),
                              label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
                              group: x.tipo,
                            };
                          })
                      )}
                      searchable
                      clearable
                      disabled={disabled || props.data.codigoEventoTipo === TipoCodigo.Comissao}
                      {...form.getInputProps('quantidadeOrigemIdUnidadeMedida')}
                    />
                    {/* {form.values.documentoImportado && (
                    <Text size="sm" c={Feature.Home.Event.color}>
                      Valor Importado: {form.values.documentoImportado}
                    </Text>
                  )} */}
                  </Group>
                </Grid.Col>
                <Grid.Col span={2}>
                  <Input.Wrapper
                    label="Quantidade de Destino"
                    required={
                      props.data.codigoEventoTipo !== TipoCodigo.Comissao &&
                      calculationQuantitySource === CalculationQuantitySource.Destination
                    }
                  >
                    <div />
                  </Input.Wrapper>
                  <Group gap="xs">
                    <NumberInput
                      style={{ width: 125 }}
                      placeholder="Quantidade"
                      // min={!isUnit ? 0 : 1}
                      // decimalScale={!isUnit ? 3 : 0}
                      // step={!isUnit ? 0.001 : 1}
                      min={0}
                      decimalScale={3}
                      step={0.001}
                      stepHoldDelay={500}
                      stepHoldInterval={(t) => Math.max(1000 / t ** 2, 25)}
                      disabled={disabled || props.data.codigoEventoTipo === TipoCodigo.Comissao}
                      {...form.getInputProps('quantidadeDestino')}
                    />
                    <Select
                      leftSection={<IconRuler2 size={15} />}
                      placeholder="Selecione..."
                      data={transformComboBoxGroupDataFromV5toV7(
                        props.referenceData.unitOfMeasures
                          .filter(
                            (x) =>
                              x.tipo === 'Massa' ||
                              x.tipo === 'Volume' ||
                              (x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
                          )
                          .map((x) => {
                            return {
                              value: x.idUnidadeMedida.toString(),
                              label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
                              group: x.tipo,
                            };
                          })
                      )}
                      searchable
                      clearable
                      disabled={disabled || props.data.codigoEventoTipo === TipoCodigo.Comissao}
                      {...form.getInputProps('quantidadeDestinoIdUnidadeMedida')}
                    />
                  </Group>
                </Grid.Col>
              </Grid>
            </Fieldset>

            <Space h="xs" />

            <SimpleGrid cols={1}>
              <Textarea
                leftSection={<IconNotes size={15} />}
                label="Observação"
                placeholder="Observação sobre a evento"
                autosize
                maxLength={500}
                disabled={disabled}
                {...form.getInputProps('observacao')}
              />
            </SimpleGrid>
          </form>
        </Paper>
        <Space h="lg" />

        <Paper shadow="xs" p="md" withBorder>
          <MovementFormView
            key={data.key}
            ref={refMovementForm}
            editable={!disabled}
            event={props.data}
            data={{ ...data, comissao: props.data.referencia?.comissao || null }}
            referenceData={props.referenceData}
            zIndex={props.zIndex + 1}
          />
        </Paper>
      </Paper>
    </div>
  );
}
